// src/data/dummyData.js

export const dummySkills = [
  {
    id: 1,
    name: "Web Development",
    description: "Building responsive and dynamic web applications",
    icon: "🌐", // Will fallback to emoji if no image
    proficiency: 95,
    category: "Development",
  },
  {
    id: 2,
    name: "Mobile Development",
    description: "Creating cross-platform mobile applications",
    icon: "📱",
    proficiency: 90,
    category: "Development",
  },
  {
    id: 3,
    name: "Game Development",
    description: "Developing interactive games and experiences",
    icon: "🎮",
    proficiency: 25,
    category: "Development",
  },
  {
    id: 4,
    name: "Automation",
    description: "Building automated workflows and scripts",
    icon: "⚡",
    proficiency: 85,
    category: "DevOps",
  },
  {
    id: 5,
    name: "API Development",
    description: "Designing and building RESTful APIs",
    icon: "🔌",
    proficiency: 92,
    category: "Backend",
  },
];

export const dummyTechnologies = [
  {
    id: 1,
    name: "React.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    category: "Frontend",
    proficiency: 95,
    color: "#61DAFB",
    yearsExp: 3,
  },
  {
    id: 2,
    name: "React Native",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    category: "Mobile",
    proficiency: 90,
    color: "#61DAFB",
    yearsExp: 2,
  },
  {
    id: 3,
    name: "Node.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    category: "Backend",
    proficiency: 90,
    color: "#339933",
    yearsExp: 3,
  },
  {
    id: 4,
    name: "MongoDB",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    category: "Database",
    proficiency: 85,
    color: "#47A248",
    yearsExp: 2,
  },
  {
    id: 5,
    name: "TypeScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    category: "Language",
    proficiency: 88,
    color: "#3178C6",
    yearsExp: 2,
  },
  {
    id: 6,
    name: "Python",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    category: "Language",
    proficiency: 82,
    color: "#3776AB",
    yearsExp: 3,
  },
  {
    id: 7,
    name: "Express.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
    category: "Backend",
    proficiency: 88,
    color: "#000000",
    yearsExp: 3,
  },
  {
    id: 8,
    name: "PostgreSQL",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
    category: "Database",
    proficiency: 80,
    color: "#336791",
    yearsExp: 2,
  },
  {
    id: 9,
    name: "Docker",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    category: "DevOps",
    proficiency: 75,
    color: "#2496ED",
    yearsExp: 1,
  },
  {
    id: 10,
    name: "AWS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg",
    category: "Cloud",
    proficiency: 78,
    color: "#FF9900",
    yearsExp: 2,
  },
  {
    id: 11,
    name: "Vue.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
    category: "Frontend",
    proficiency: 70,
    color: "#4FC08D",
    yearsExp: 1,
  },
  {
    id: 12,
    name: "Firebase",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
    category: "Cloud",
    proficiency: 85,
    color: "#FFCA28",
    yearsExp: 2,
  },
];